import { Input, InputGroup } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React, { forwardRef } from 'react';
type SearchHeaderInputProps = {
  inputGroupProps?: Omit<ComponentProps<typeof InputGroup>, 'children'> & {
    endElement?: React.ReactNode;
  };
  isLoading?: boolean;
  hasValue?: boolean;
} & ComponentProps<typeof Input>;
const SearchHeaderInput = forwardRef<HTMLInputElement, SearchHeaderInputProps>(({
  inputGroupProps,
  ...props
}, ref) => {
  return <InputGroup alignItems="center" backgroundColor="white" borderRadius="4px" gap={3} height="40px" paddingX="15px" width="100%" {...inputGroupProps}>
      <Input ref={ref} border="none" color="neutral.900" textStyle="paragraph.small" padding={0} placeholder="Find your products" _focus={{
      outline: 'none'
    }} _focusVisible={{
      outline: 'none'
    }} _placeholder={{
      color: 'neutral.400'
    }} {...props} />
    </InputGroup>;
});
export default SearchHeaderInput;